/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListActivities200ResponseMetaLinksInner } from './ListActivities200ResponseMetaLinksInner';
import {
    ListActivities200ResponseMetaLinksInnerFromJSON,
    ListActivities200ResponseMetaLinksInnerFromJSONTyped,
    ListActivities200ResponseMetaLinksInnerToJSON,
    ListActivities200ResponseMetaLinksInnerToJSONTyped,
} from './ListActivities200ResponseMetaLinksInner';

/**
 * 
 * @export
 * @interface ListBazaarItems200ResponseMeta
 */
export interface ListBazaarItems200ResponseMeta {
    /**
     * 
     * @type {number}
     * @memberof ListBazaarItems200ResponseMeta
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ListBazaarItems200ResponseMeta
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof ListBazaarItems200ResponseMeta
     */
    lastPage?: number;
    /**
     * 
     * @type {Array<ListActivities200ResponseMetaLinksInner>}
     * @memberof ListBazaarItems200ResponseMeta
     */
    links?: Array<ListActivities200ResponseMetaLinksInner>;
    /**
     * 
     * @type {string}
     * @memberof ListBazaarItems200ResponseMeta
     */
    path?: string;
    /**
     * 
     * @type {number}
     * @memberof ListBazaarItems200ResponseMeta
     */
    perPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ListBazaarItems200ResponseMeta
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof ListBazaarItems200ResponseMeta
     */
    total?: number;
}

/**
 * Check if a given object implements the ListBazaarItems200ResponseMeta interface.
 */
export function instanceOfListBazaarItems200ResponseMeta(value: object): value is ListBazaarItems200ResponseMeta {
    return true;
}

export function ListBazaarItems200ResponseMetaFromJSON(json: any): ListBazaarItems200ResponseMeta {
    return ListBazaarItems200ResponseMetaFromJSONTyped(json, false);
}

export function ListBazaarItems200ResponseMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListBazaarItems200ResponseMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['current_page'] == null ? undefined : json['current_page'],
        'from': json['from'] == null ? undefined : json['from'],
        'lastPage': json['last_page'] == null ? undefined : json['last_page'],
        'links': json['links'] == null ? undefined : ((json['links'] as Array<any>).map(ListActivities200ResponseMetaLinksInnerFromJSON)),
        'path': json['path'] == null ? undefined : json['path'],
        'perPage': json['per_page'] == null ? undefined : json['per_page'],
        'to': json['to'] == null ? undefined : json['to'],
        'total': json['total'] == null ? undefined : json['total'],
    };
}

export function ListBazaarItems200ResponseMetaToJSON(json: any): ListBazaarItems200ResponseMeta {
    return ListBazaarItems200ResponseMetaToJSONTyped(json, false);
}

export function ListBazaarItems200ResponseMetaToJSONTyped(value?: ListBazaarItems200ResponseMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current_page': value['currentPage'],
        'from': value['from'],
        'last_page': value['lastPage'],
        'links': value['links'] == null ? undefined : ((value['links'] as Array<any>).map(ListActivities200ResponseMetaLinksInnerToJSON)),
        'path': value['path'],
        'per_page': value['perPage'],
        'to': value['to'],
        'total': value['total'],
    };
}

